import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index'
import { BootstrapVue } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTrash, faEllipsisV, faUserCircle, faBars, faBell, faUser, faSearch, faChevronRight, faChevronDown, faClipboardList, faTools, faEye, faUserCog, faCalendarDay, faSave,
  faExpand, faEdit, faTrashAlt, faChevronLeft, faHome, faFileExcel, faPrint, faDownload, faPlus, faArrowLeft, faArrowDown, faChevronUp, faPaperPlane, faFileMedicalAlt, faBroom,
  faCheckCircle, faClock, faSyncAlt,faFilter,faHouseUser,faArrowUp,faInbox
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faTrash, faEllipsisV, faUserCircle, faHome, faBars, faBell, faUser, faSearch, faChevronRight, faChevronDown, faClipboardList, faFileExcel, faSave,
  faTools, faEye, faUserCog, faExpand, faEdit, faTrashAlt, faChevronLeft, faCalendarDay, faPrint, faDownload, faPlus, faArrowLeft, faArrowDown, faChevronUp, faPaperPlane,
  faFileMedicalAlt, faBroom, faCheckCircle, faClock, faSyncAlt,faFilter,faHouseUser,faArrowUp,faInbox)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/main.css'
import VueEllipseProgress from 'vue-ellipse-progress';
import axios from 'axios'
import {generateTokenApiGee} from './assets/js/common'
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueEllipseProgress);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.prototype.$axios = axios
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
axios.interceptors.request.use((config) => {
  
  return config
})
axios.interceptors.response.use((response) => {
  
  console.log(response)
  return response
}, (error) => {
  // Handle errors here
  if (error.response.status === 401) {
    // Redirect to login page
    generateTokenApiGee();
    //router.push('/login')
  }
  console.error(error)
  return Promise.reject(error)
}) 

